<mat-card
  class="balance-charges-panel default has-progress-bar"
  [class.balance-charges-panel--read-only]="readOnly"
  data-balance-charges-panel
>
  @if (!readOnly) {
    <mat-progress-bar [mode]="loading ? 'indeterminate' : 'determinate'"></mat-progress-bar>

    <mat-card-title
      *ngIf="!readOnly && !hideCalculate"
      class="balance-charges-panel__title"
      fxLayout="row"
      fxLayoutAlign="space-between center"
      fxLayoutGap="10px">
      <span fxFlex class="balance-charges-panel__heading">{{ 'balance.charges.title' | translate }}</span>
      <mmx-balance-charges-toolbar
        *ngIf="!hideCalculate"
        [canResetByTemplate]="canResetByTemplate"
        [canResetByEstimate]="canResetByEstimate"
        [canCalculate]="(canCalculate$ | async) ?? false"
        [busy]="busy"
        [templateMenu]="estimateMenu"
        (reset)="onReset($event)"
        (calculate)="onCalculate()">
      </mmx-balance-charges-toolbar>
    </mat-card-title>
  }


  <mat-card-content [formGroup]="estimateForm">
    <div
      class="balance-charges-panel__row mb-2"
      fxLayout="row"
      fxLayoutAlign="space-between start"
      fxLayoutGap="1rem"
    >
      <mmx-balance-charges-appointment-picker
        fxFlex
        class="balance-charges-panel__appointments"
        [patientId]="estimate?.patientId ?? null"
        [selectedIds]="(selectedAppointmentIds$ | async) ?? []"
        [cocMode]="cocMode"
        [unscheduledSelected]="unscheduledSelected"
        [readOnly]="readOnly"
        [modeLocked]="modeLocked"
        (selectionChange)="onAppointmentChange($event)"
        (cocModeChange)="onCocModeChange($event)"
        (unscheduledChange)="onUnscheduledChange($event)">
      </mmx-balance-charges-appointment-picker>

      <mat-form-field fxFlex class="balance-charges-panel__facility" subscriptSizing="dynamic">
        <mat-label>{{ 'common.facility' | translate }}</mat-label>
        <mmx-facility-selector-input
          formControlName="facilityId"
          required>
        </mmx-facility-selector-input>
      </mat-form-field>
    </div>

    <mmx-balance-charges-coc-summary
      *ngIf="cocMode"
      [selectedAppointments]="(selectedAppointments$ | async) ?? []"
      [charges]="estimate?.charges ?? []"
      [unscheduledMode]="unscheduledSelected"
      [warnings]="estimate?.output?.warnings ?? []">
    </mmx-balance-charges-coc-summary>

    <div *ngIf="claimSearchEnabled && !readOnly" [class.mx-5]="hideCalculate">
      <mmx-model-claim-search
        [facilityId]="estimateForm.controls.facilityId.value"
        [serviceType]="patientType"
        [physicianId]="selectedPhysicianId$ | async"
        [prefillQuery]="claimSearchPrefillQuery"
        [estimateId]="estimate?.id"
        [showTraceButton]="showMcsResponse"
        [traceButtonDisabled]="busy"
        (modelClaim)="onClaimAdded($event)"
        (traceRequested)="onMcsResponse()"
      >
      </mmx-model-claim-search>
    </div>

    <ng-container *ngIf="estimate">
      <p
        *ngIf="readOnly && (estimate?.charges?.length ?? 0) === 0"
        class="balance-charges-panel__empty"
        data-balance-charges-empty
      >
        {{ 'balance.charges.empty' | translate }}
      </p>
      <div [class.mb-5]="hideCalculate">
        <mmx-charges-table-form
          *ngIf="!readOnly || (estimate?.charges?.length ?? 0) > 0"
          [facilityIds]="(facilityIds$ | async) ?? []"
          [chargesFormArray]="estimateForm.controls.charges"
          [appointmentOptions]="appointmentOptions"
          [readOnly]="readOnly"
          [showVisitNumbers]="cocMode"
          [forceFreeTextVisitNumbers]="cocMode"
          [maxVisitNumber]="maxVisitNumber"
          (change)="onChargesChanged()"
          (valueUpdated)="onChargesChanged()"
          (addChargeDiscountControl)="onAddDiscount($event)"
          (removeChargeDiscountControl)="onRemoveDiscount($event)">
        </mmx-charges-table-form>
      </div>
    </ng-container>
  </mat-card-content>
</mat-card>

<mat-menu #estimateMenu="matMenu">
  <mmx-estimate-template-menu
    (click)="$event.stopPropagation()"
    [facilityId]="estimateForm.controls.facilityId.value"
    (templateSelected)="onTemplateSelected($event)">
  </mmx-estimate-template-menu>
</mat-menu>
